import { render, staticRenderFns } from "./RecipeView.vue?vue&type=template&id=783214aa&"
import script from "./RecipeView.vue?vue&type=script&lang=js&"
export * from "./RecipeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports